// extracted by mini-css-extract-plugin
export default {"controls":"AppointmentControls_controls__UcITp","controllerContainer":"AppointmentControls_controllerContainer__1ixJN","controllerLabel":"AppointmentControls_controllerLabel__C77NX"};